{
  "account": {
    "title": "Akun Saya",
    "list": {
      "title": "Akun",
      "description": "Daftar faktur akun yang terhubung"
    },
    "form": {
      "name": {
        "title": "Nama",
        "description": "Nama akun Anda"
      },
      "password": {
        "title": "Kata Sandi",
        "description": "Atur kata sandi baru untuk akun Anda, biarkan kosong untuk mempertahankan kata sandi saat ini"
      },
      "emailPreferences": {
        "title": "Preferensi email",
        "description": "Pilih jenis notifikasi email"
      }
    },
    "billing": "Detail penagihan",
    "subscriptions": "Langganan",
    "manageSubscription": "Kelola langganan",
    "popup": {
      "cancel": "Apakah Anda yakin ingin membatalkan langganan Anda? <br/>Website Anda akan terus diterjemahkan sampai akhir periode langganan saat ini. Setelah itu, terjemahan akan dinonaktifkan.<br/>Harap dicatat bahwa Anda tidak berhak atas pengembalian dana untuk periode yang tidak terpakai.",
      "downgrade": "Apakah Anda yakin ingin menurunkan paket? Penurunan paket akan berlaku segera.<br/>Harap dicatat bahwa Anda tidak berhak atas pengembalian dana untuk sisa waktu siklus penagihan saat ini.<br/>Harga paket baru akan diterapkan pada siklus penagihan berikutnya.",
      "default": "Apakah Anda yakin ingin mengubah paket Anda?",
      "resume": "Apakah Anda yakin ingin melanjutkan langganan Anda?"
    }
  },
  "ai_translation": {
    "header": "Terjemahan AI",
    "plan": {
      "header": "Harga Terjemahan AI",
      "used": "Anda telah menggunakan {words_used} / {words_allowed} kata terjemahan dalam kredit AI Anda.",
      "remaining": "Kredit AI tersedia:",
      "words": "kata",
      "add_more_credits": "Tambah kredit AI lagi",
      "details": {
        "idiomatic_expressions": "Ekspresi idiomatik dan teknis",
        "background_translation": "Terjemahan di latar belakang",
        "best_website": "Website yang membutuhkan kualitas terjemahan sempurna",
        "page_context": "Konteks halaman dan website untuk terjemahan",
        "perfect_quality": "Kualitas sempurna, harga terjangkau",
        "no_recurring": "Tanpa pembayaran berulang, kuota pra-bayar",
        "save_40": "Hemat 40% dibandingkan paket $20",
        "save_50": "Hemat 50% dibandingkan paket $20"
      },
      "quota": "{estimated_words} kata ~ {estimated_pages} halaman"
    },
    "settings": {
      "banner": {
        "title": "Terjemahan AI Linguise",
        "intro": "Linguise dengan bangga mempersembahkan Linguise AI Translation, fitur premium baru yang memanfaatkan model AI LLM (model Llama terbaru, dioptimalkan untuk tugas terjemahan). Dirancang untuk website yang menuntut akurasi sempurna, fitur ini mempertimbangkan konteks halaman maupun seluruh situs untuk hasil tak tertandingi. Tawarkan kepada klien Anda kualitas terjemahan tertinggi, memastikan pesan mereka terdengar sempurna dalam setiap bahasa.",
        "button": "Upgrade sekarang"
      },
      "alert": {
        "description": "Fitur ini tidak termasuk dalam paket Anda saat ini dan memerlukan pembelian terpisah.\nAktifkan add-on ini untuk membuka semua opsi di bawah ini."
      },
      "languages": {
        "title": "Terapkan terjemahan AI pada bahasa",
        "description": "Pilih bahasa spesifik tempat Anda ingin terjemahan AI diterapkan"
      },
      "button": {
        "save": "Simpan pengaturan"
      },
      "form": {
        "advanced": {
          "title": "Instruksi AI lanjutan",
          "description": "Instruksi AI lanjutan"
        },
        "enable_mode": {
          "title": "AKTIFKAN TERJEMAHAN AI",
          "description": "Pilih cara Anda ingin mengaktifkan terjemahan AI.\n\"Hanya aturan\" akan menerapkan aturan berikut.\n\"Hanya editor antarmuka\" akan memungkinkan mengaktifkan terjemahan halaman per halaman dari tampilan editor antarmuka.\n\"Aturan dan editor antarmuka\" akan menggunakan kedua fitur tersebut.",
          "disabled": "Dinonaktifkan",
          "rules": "Hanya aturan",
          "live_editor": "Hanya editor antarmuka",
          "all": "Aturan dan editor antarmuka"
        },
        "rule_application": {
          "description": "Terapkan Terjemahan AI pada konten statis atau dinamis atau keduanya",
          "title": "Terapkan pada konten",
          "all": "Semua konten",
          "static": "Konten statis",
          "dynamic": "Konten dinamis"
        },
        "website_topic": {
          "title": "Topik website",
          "placeholder": "Restoran sushi...",
          "description": "Tentukan topik website Anda untuk kualitas terjemahan yang lebih baik (mis. Legal, restoran sushi, toko suku cadang sepeda…)\nSilakan masukkan topik website dalam bahasa Inggris."
        },
        "apply_to_urls": {
          "title": "Terapkan pada URL",
          "description": "Pilih URL spesifik tempat Anda ingin terjemahan AI diterapkan",
          "all_urls": "Semua URL",
          "selected_urls": "URL terpilih",
          "label": "URL untuk diterapkan",
          "placeholder": "URL untuk diterapkan",
          "wildcard": "Karakter pengganti",
          "regex": "Ekspresi reguler",
          "add": "Tambah baru",
          "expression": "Tipe ekspresi"
        },
        "apply_languages": {
          "title": "Terapkan pada bahasa",
          "description": "Pilih bahasa spesifik tempat Anda ingin terjemahan AI diterapkan",
          "all_languages": "Semua bahasa",
          "selected_languages": "Bahasa terpilih",
          "placeholder": "Pilih bahasa...",
          "feedback": "Anda harus memilih sebuah bahasa"
        },
        "formality": {
          "title": "Formalitas",
          "description": "Tentukan tingkat formalitas dalam terjemahan, yang mungkin penting bagi audiens dan konteks.\n\"Netral\" akan mencoba mempertahankan formalitas konten asli.\n\"Formal\" untuk konten profesional, bisnis, atau legal (mis. menggunakan kata ganti formal seperti \"Anda\" dalam bahasa Indonesia).\n\"Informal\" untuk konten santai, percakapan (mis. menggunakan \"kamu\").",
          "neutral": "Netral",
          "formal": "Formal",
          "informal": "Informal"
        },
        "sentence_structure": {
          "classic": "Klasik",
          "short": "Kalimat pendek dan tajam",
          "detailed": "Kalimat detail dan penjelas",
          "title": "Struktur kalimat",
          "description": "Tentukan preferensi gaya penulisan."
        },
        "content_purpose": {
          "marketing": "Pemasaran/promosi (gaya persuasif, menarik)",
          "technical": "Teknis/instruksional (jelas, tepat, berorientasi aksi)",
          "support": "Dukungan pelanggan (empatik, membantu, menenangkan)",
          "legal": "Legal/kepatuhan (tepat, formal, tidak ambigu)",
          "educational": "Edukasi (jelas, terstruktur, mudah dipahami)",
          "other": "Lainnya (Dalam Bahasa Inggris)",
          "title": "Tujuan konten",
          "description": "Tentukan tujuan fungsional dari konten yang diterjemahkan.",
          "other_placeholder": "Deskripsikan tujuan..."
        },
        "target_audience": {
          "title": "Audiens target",
          "description": "Spesifikasi audiens yang dituju dari konten terjemahan (dalam Bahasa Inggris).",
          "placeholder": "misalnya, orang tua berbahasa Spanyol, petugas privasi Uni Eropa"
        },
        "override_default_translations": {
          "title": "Timpa terjemahan default",
          "description": "Jika diset ke YA, opsi ini akan memaksa konten diterjemahkan dengan AI (Linguise AI) meskipun sudah diterjemahkan oleh Cloud AI translation (model terjemahan default)."
        },
        "force_replace_before": {
          "title": "Paksa terjemahkan ulang dengan AI",
          "description": "Terjemahkan ulang dengan AI semua konten yang terjemahan AI-nya dibuat sebelum tanggal yang dipilih — misalnya konten yang diterjemahkan dengan model lama. Terjemahan ulang dilakukan saat halaman yang diterapkan dikunjungi berikutnya sesuai Rules, dan menggunakan kredit AI Anda.",
          "before_date": "Sebelum tanggal"
        },
        "model": {
          "current": "Saat ini",
          "title": "Model",
          "description": "Pilih model terjemahan LLM yang ingin Anda gunakan",
          "load_error": "Tidak dapat memuat model yang tersedia. Silakan coba lagi nanti.",
          "thinking_warning": "Model ini menggunakan tingkat penalaran yang tinggi (\"berpikir\") dan akan mengonsumsi jauh lebih banyak token per terjemahan."
        },
        "override_manual_and_selected": {
          "no_default": "Tidak (default)",
          "title": "Timpa terjemahan manual dan yang dipilih",
          "description": "Secara default, terjemahan yang Anda edit secara manual selalu tetap tampil di situs web Anda, bahkan setelah terjemahan yang ditingkatkan AI dibuat. Setel ke YA untuk menampilkan terjemahan yang ditingkatkan AI sebagai gantinya. Terjemahan manual Anda tetap tersimpan dan Anda dapat kembali kapan saja. Ini juga berlaku saat Anda menerjemahkan ulang halaman untuk mendapatkan terjemahan baru; terjemahan terbaru akan digunakan secara otomatis."
        }
      },
      "message": {
        "save_success": "Dari konten yang sudah diterjemahkan saat ini, jumlah halaman yang akan ditingkatkan dengan terjemahan AI sekitar {{ai_affected_urls}}.",
        "save_success_only": "Pengaturan berhasil disimpan."
      }
    },
    "pricing": {
      "plan": {
        "title": "Pesan kuota terjemahan AI",
        "buy_button": "BELI PAKET TERJEMAHAN AI"
      },
      "modal": {
        "title": "Konfirmasi perubahan paket",
        "description": "Apakah Anda yakin ingin mengubah paket Terjemahan AI Anda?",
        "button_cancel": "Batal",
        "button_confirm": "Konfirmasi",
        "loading": "Harap tunggu...",
        "amount": "Jumlah",
        "credit": "Kredit",
        "total_due": "Total yang harus dibayar"
      },
      "comparison": {
        "title": "Terjemahan AI Google Cloud\nvs terjemahan AI Linguise",
        "list": {
          "0": {
            "google": "Terjemahan cepat dan andal",
            "linguise": "Menangani ekspresi idiomatik dan teknis"
          },
          "1": {
            "google": "Terjemahan instan semua halaman situs web",
            "linguise": "Pembuatan terjemahan di latar belakang"
          },
          "2": {
            "google": "Kualitas terbaik, harga rendah",
            "linguise": "Kualitas sempurna, harga terjangkau"
          },
          "3": {
            "google": "Cocok untuk situs besar atau anggaran rendah",
            "linguise": "Terbaik untuk situs yang memerlukan kualitas terjemahan sempurna"
          },
          "4": {
            "google": "Konteks halaman untuk terjemahan",
            "linguise": "Konteks halaman dan situs untuk terjemahan"
          }
        }
      },
      "botom_banner": {
        "title": "Rasakan Akurasi Terjemahan Tiada Tara dengan",
        "sub_title": "Linguise AI Translation Baru",
        "description": "Linguise meningkatkan layanan terjemahan otomatisnya dengan memperkenalkan Linguise AI Translation, opsi baru yang kuat menggunakan AI terjemahan LLM mutakhir (model Llama terbaru yang dioptimalkan untuk terjemahan). Penambahan ini memberikan pengembang situs web dan agensi web kualitas terjemahan tingkat lebih tinggi, ideal untuk proyek yang mengutamakan kesempurnaan. Linguise AI Translation melengkapi terjemahan AI Google Cloud kami yang sudah berkualitas tinggi, menawarkan fleksibilitas dan presisi lebih besar."
      }
    },
    "success": {
      "tab_title": "Terima kasih telah membeli paket AI Translation!",
      "title": "Terima kasih telah membeli paket AI Translation!",
      "subtitle": "Paket AI Translation Anda telah berhasil dibeli!",
      "message": "Anda dapat mengelola paket AI Translation di halaman pengaturan AI Translation.",
      "home": "Kelola AI Translation"
    }
  },
  "billing": {
    "form": {
      "name": {
        "title": "Nama",
        "description": "Nama akun penagihan"
      },
      "phone": {
        "title": "Telepon",
        "description": "Telepon akun penagihan"
      },
      "email": {
        "title": "Email",
        "description": "Email akun penagihan"
      },
      "address": {
        "title": "Alamat",
        "description": "Alamat akun penagihan",
        "city": "Kota",
        "country": "Negara",
        "address1": "Alamat 1",
        "address2": "Alamat 2",
        "postal": "Kode pos",
        "state": "Provinsi"
      },
      "tax": {
        "title": "Nomor pajak"
      }
    }
  },
  "checkouts": {
    "header": "Pembayaran",
    "payment_method": "Pilih Metode Pembayaran",
    "stripe_card": "Kartu kredit (Stripe)",
    "paypal": "PayPal",
    "address": {
      "new": "Masukkan alamat penagihan baru",
      "existing": "Gunakan alamat yang ada"
    },
    "pay_stripe": "Konfirmasi dan bayar",
    "terms": "Dengan mengonfirmasi langganan Anda, Anda mengizinkan Linguise menagih Anda untuk pembayaran mendatang sesuai dengan ketentuan kami. Anda selalu dapat membatalkan langganan Anda.",
    "coupon": {
      "title": "Punya kupon?",
      "placeholder": "Masukkan kode kupon Anda di sini",
      "apply": "Terapkan",
      "percent": "{{0}}% diskon"
    },
    "add_new": "Tambah baru",
    "use_existing": "Gunakan metode pembayaran yang ada",
    "recurring": {
      "month_single": "Ditagih bulanan",
      "month_many": "Ditagih setiap {{count}} bulan",
      "year_single": "Ditagih tahunan",
      "year_many": "Ditagih setiap {{count}} tahun",
      "day_single": "Ditagih harian",
      "day_many": "Ditagih setiap {{count}} hari",
      "week_single": "Ditagih mingguan",
      "week_many": "Ditagih setiap {{count}} minggu"
    },
    "add_new_no_stripe": "Tambah kartu baru",
    "summary": {
      "title": "Ringkasan",
      "subtotal": "Subtotal",
      "total": "Total"
    }
  },
  "dashboard": {
    "main": {
      "title": "Dasbor"
    },
    "statistics": {
      "main_title": "Statistik 30 hari terakhir",
      "characters": "Karakter yang diterjemahkan",
      "words": "Kata yang diterjemahkan",
      "bandwidth": "Bandwidth input",
      "request": "Permintaan",
      "page_views": "Tampilan halaman per bahasa (30 hari terakhir)",
      "multilingual_views": "Tampilan halaman multibahasa (30 hari terakhir)",
      "most_page_viewed": "20 Halaman paling banyak dilihat (30 hari terakhir)",
      "no_data_yet": "Belum ada data tersedia",
      "th_language": "Bahasa",
      "th_page_views": "Tampilan halaman",
      "real_visitors": "Pengunjung nyata",
      "crawler": "Perayap web"
    },
    "planHints": {
      "subscribeButton": "Berlangganan",
      "upgradeButton": "Tingkatkan",
      "usedWords": "Anda saat ini menggunakan {words_used} kata",
      "noPlan": "Tidak ada paket yang diaktifkan untuk domain ini. Berlangganan paket dan mulai menerjemahkan situs web Anda",
      "noPlanShopify": "Tidak ada paket yang diaktifkan untuk domain ini. Berlangganan paket di dasbor Shopify Anda dan mulai menerjemahkan situs web Anda",
      "trialUsage": "Anda saat ini menggunakan {words_used} kata dari {words_allowed} kata yang termasuk dalam paket percobaan.",
      "trialEnds": "Percobaan bulan pertama diaktifkan hingga {trial_ends}.",
      "subscribeMessage": "Berlangganan sebelum habis untuk menjaga situs web Anda tetap diterjemahkan",
      "subscribeMessageShopify": "Berlangganan dari dasbor Shopify Anda sebelum habis untuk menjaga situs web Anda tetap diterjemahkan",
      "trialReachedLimit": "Anda telah mencapai batas maksimum kata yang diterjemahkan untuk periode percobaan.\nBerlangganan salah satu paket kami untuk melanjutkan penerjemahan situs web Anda.",
      "paidUsage": "Anda telah menggunakan {words_used} / {words_allowed} kata yang diterjemahkan dalam paket Anda.",
      "paidReachedLimit": "Anda telah mencapai batas maksimum kata yang diterjemahkan untuk paket saat ini.\nUpgrade paket Anda untuk melanjutkan penerjemahan konten situs web Anda.",
      "trialOfferedUsage": "Anda saat ini menggunakan {words_used} kata dari {words_allowed} kata yang termasuk dalam paket percobaan (Termasuk {free_words} kata gratis).",
      "paidOfferedUsage": "Anda telah menggunakan {words_used} / {words_allowed} kata yang diterjemahkan dalam paket Anda (Termasuk {free_words} kata gratis).",
      "noPlanExtra": "Harap dicatat bahwa domain tidak aktif dan datanya akan dihapus secara otomatis secara berkala.",
      "planRecommended": "Berdasarkan volume terjemahan Anda saat ini, paket yang direkomendasikan adalah:",
      "planMaximumWords": "{{words}} kata",
      "notHaveTranslatedWords": "Anda belum melakukan terjemahan apa pun"
    },
    "translationSetup": {
      "kicker": "PENYIAPAN SUBDOMAIN",
      "title": "Periksa penyiapan terjemahan",
      "description": "Tinjau DNS, host terjemahan, akses ke situs asal, dan batas akun.",
      "starting": "Memeriksa...",
      "button": "Periksa penyiapan",
      "viewLatest": "Lihat hasil terbaru",
      "viewCurrent": "Lihat pemeriksaan saat ini",
      "runAgain": "Jalankan pemeriksaan lagi",
      "viewDetails": "Lihat detail",
      "hideDetails": "Sembunyikan detail",
      "error": "Penyiapan tidak dapat diperiksa",
      "allPassed": "Semua pemeriksaan berhasil",
      "setupNeedsAttention": "Penyiapan memerlukan perhatian",
      "setupNeedsAttentionDescription": "Satu atau beberapa pemeriksaan gagal. Tinjau item di bawah atau hubungi dukungan Linguise.",
      "lastChecked": "Terakhir diperiksa {{time}}",
      "domainOwnership": "Kepemilikan domain",
      "domainOwnershipDescription": "Catatan verifikasi ditemukan",
      "domainOwnershipFailure": "Catatan DNS kepemilikan tidak dapat diverifikasi.",
      "translatedHosts": "Host terjemahan",
      "translatedHostsDescription": "{{count}} host bahasa diperiksa",
      "translatedHostsFailure": "Satu atau beberapa catatan CNAME bahasa salah.",
      "subdomainPage": "Halaman subdomain",
      "subdomainPageDescription": "{{count}} halaman terjemahan menerima HTTPS",
      "subdomainPageFailure": "Koneksi TLS gagal saat membuka satu atau beberapa halaman terjemahan.",
      "originalSite": "Situs asal",
      "originalSiteDescription": "Pemeriksaan DNS, TLS, dan respons situs asal",
      "originalSiteFailure": "Pemeriksaan DNS, TLS, atau respons situs asal gagal.",
      "documentationAdvice": {
        "dns": "Tinjau penyiapan DNS",
        "tls": "Tinjau penyiapan HTTPS",
        "origin": "Tinjau penyiapan situs asal",
        "diagnostic": "Tinjau langkah pemecahan masalah"
      },
      "evidence": {
        "originDns": "DNS asal",
        "originTls": "TLS asal",
        "originHttp": "Respons asal",
        "observedTargets": "Target yang terdeteksi",
        "recordCount": "Catatan ditemukan",
        "addressCount": "Alamat ditemukan",
        "statusCode": "Status HTTP",
        "redirect": "Pengalihan",
        "expiresAt": "Sertifikat kedaluwarsa",
        "raw": "{{key}}",
        "noValue": "Tidak ada nilai"
      },
      "checkerError": "Beberapa pemeriksaan tidak dapat diselesaikan.",
      "coreLocation": "Diperiksa dari {{location}}",
      "status": {
        "queued": "Dalam antrean",
        "running": "Berjalan",
        "completed": "Selesai",
        "failed": "Gagal",
        "passed": "Lulus",
        "warning": "Peringatan",
        "unknown": "Tidak diketahui",
        "skipped": "Dilewati",
        "not_applicable": "Tidak berlaku"
      }
    },
    "throttling": {
      "title": "Batas terjemahan",
      "description": "Batas penggunaan sementara",
      "unavailable": "Batas terjemahan sementara tidak tersedia",
      "window": "{{used}} / {{max}} kata",
      "resetsIn": "Direset dalam {{time}}",
      "throttled": "Terjemahan dijeda sementara",
      "throttledDescription": "Batas penggunaan sementara telah tercapai. Terjemahan akan dilanjutkan saat periode ini direset."
    }
  },
  "domain": {
    "wizard": {
      "stepLabel": "LANGKAH {{step}} DARI {{total}}",
      "doneLabel": "SELESAI, ANDA BISA MULAI MENERJEMAHKAN!",
      "finish": {
        "title": "",
        "description": "Ini adalah kunci API yang digunakan di situs web Anda"
      },
      "instructions": "Instruksi pemasangan",
      "domainSetting": "Pengaturan domain",
      "step": {
        "titleWordpress": "Wordpress",
        "titleJoomla": "Joomla",
        "titlePHP": "Skrip PHP",
        "wizardWordpressStep1": "1. Instal ",
        "wizardWordpressStep2": "\n 2. Di pengaturan plugin salin dan isi kunci API Anda\n",
        "wizardWordpressStep3": "3. Anda siap untuk menerjemahkan\n\n",
        "wizardWordpressStep4": "Untuk instruksi yang lebih detail, silakan lihat dokumentasi kami: ",
        "wizardJoomlaStep1": "1. Tautan paket Joomla: ",
        "wizardJoomlaStep2": "\n2. Di pengaturan konfigurasi ekstensi salin dan isi kunci API Anda",
        "wizardJoomlaStep3": "3. Di konfigurasi modul, atur bahasa yang ingin Anda tampilkan, dan sisipkan modul Anda di tempat yang diperlukan.",
        "wizardJoomlaStep4": "\n 4. Anda siap untuk menerjemahkan\n\n",
        "wizardPhpStep1": "1. Unduh skrip php kami dan di sini ",
        "wizardPhpStep2": "\n2. Ikuti petunjuk instalasi di halaman dokumentasi kami di sini ",
        "wizardPhpStep3": "\n3. Tambahkan modul ke halaman Anda.",
        "wizardPhpStep4": "\n Salin kode berikut dan tambahkan ke bagian head halaman html Anda, itu akan menampilkan modul switcher secara otomatis\n",
        "dispatchStep1": "Kami telah berhasil mengirim data yang diperlukan ke plugin Linguise, Anda dapat menutup jendela berikut sekarang.",
        "dispatchStep2": "Jika token tidak muncul saat Anda menutup jendela ini, silakan salin token berikut:",
        "dispatchStep3": "Anda juga dapat menyalin snippet ini untuk mengaktifkan switcher bendera secara otomatis",
        "wizardOtherStep1": "Ikuti instruksi di bawah untuk menginstal Linguise pada domain Anda.\n",
        "wizardOtherStep2": "Salin kode berikut dan tambahkan ke bagian head halaman html Anda, itu akan menampilkan modul switcher secara otomatis.\n"
      },
      "trialAlreadyUsed": "Sepertinya Anda sudah menggunakan trial gratis Anda, jadi Anda perlu mendapatkan kuota terjemahan\nSilakan berlangganan paket atau hubungi kami jika Anda perlu memperpanjang trial Anda.",
      "usefulLinks": "Tautan berguna untuk memulai",
      "linkDocumentation": "Dokumentasi",
      "linkExtensionDl": "Unduhan ekstensi",
      "linkSubscribe": "Berlangganan paket sekarang",
      "linkDashboard": "Pergi ke dasbor",
      "exclusion": {
        "title": "Nama perusahaan dan produk",
        "description": ""
      },
      "finishButton": "Selesaikan pengaturan",
      "subdomains": "Subdomain",
      "subdomain_setup": "Pengaturan domain",
      "subdomain_auto_setup": "Hubungkan DNS Anda secara otomatis",
      "subdomain_manual_setup": "Tambahkan entri DNS sendiri",
      "subdomain_skip": "Lakukan nanti",
      "auto_subdomains_info": "CMS pembuat situs Anda memerlukan konfigurasi DNS untuk mengatur bahasa per subdomain (mis. es.domain.com).",
      "auto_subdomains_info_2": "Anda dapat melakukannya secara otomatis menggunakan Entri. Cukup klik tombol \"Hubungkan DNS Anda secara otomatis\" untuk memulai menghubungkan ke manajer DNS Anda dan menambahkannya dengan Entri.",
      "auto_subdomains_info_manual": "Atau, Anda dapat mengonfigurasi domain secara manual dengan mengklik tombol \"Tambahkan entri DNS sendiri\".",
      "breadcrumbs": {
        "step1": "Langkah 1: Domain, CMS & Bahasa",
        "step2": "Langkah 2: DNS Bahasa",
        "step3": "Langkah {{step}}: Petunjuk pemasangan"
      }
    },
    "form": {
      "urls": {
        "dash": "Tanda hubung -",
        "underscore": "Garis bawah _",
        "title": "Terjemahkan URL",
        "description": "Apakah Anda ingin menerjemahkan di semua halaman",
        "char_description": "Karakter yang digunakan untuk mengganti karakter yang tidak diizinkan dalam URL",
        "advertisement_title": "⚠ Anda telah mengatur banyak bahasa.\n",
        "advertisement": "Kami biasanya menyarankan untuk memulai menerjemahkan situs web dengan sedikit bahasa terlebih dahulu. Anda akan mendapatkan gambaran tentang berapa banyak kata yang dimiliki situs web Anda. Ini juga lebih baik untuk SEO, karena bot Google akan merayapi semua halaman Anda lebih cepat jika Anda memiliki lebih sedikit halaman pada awalnya. Setelah seminggu Anda dapat menambahkan beberapa bahasa lagi dan seterusnya."
      },
      "url": {
        "title": "Url",
        "description": "Masukkan URL domain utama Anda yang dimulai dengan http:// atau https://",
        "placeholder": "URL Domain",
        "advertisement_http": {
          "title": "Anda tidak menggunakan protokol https",
          "description": "Silakan periksa bahwa domain Anda memang tidak menggunakan protokol https, yang saat ini direkomendasikan."
        },
        "advertisement_www": {
          "title": "Subdomain Anda bukan www",
          "description": "Sebagian besar waktu subdomain default adalah www (seperti https://www.mydomain.com). Ini mungkin bukan kasus Anda tetapi harap periksa kembali bahwa domain yang ingin Anda tambahkan adalah yang benar."
        },
        "invalid_url": {
          "line1": "Kami tidak dapat menemukan domain Anda. Silakan periksa bahwa domain Anda dapat diakses secara publik melalui Internet dan tidak diarahkan ke lokasi lain.",
          "line2": "Jika Anda yakin domain Anda dapat diakses, Anda dapat melewati verifikasi domain dan menekan tombol \"Langkah berikutnya\" lagi",
          "contact": "Dalam hal apapun Anda dapat menghubungi kami di",
          "force": "Lewati verifikasi domain"
        },
        "invalid_subdomain_url": "URL ini tidak diizinkan. Subdomain harus dalam format: https://www.domain.tld atau https://domain.tld tanpa subdirektori"
      },
      "account": {
        "title": "Akun",
        "description": "Pilih akun untuk menetapkan domain ini",
        "placeholder": "Pilih akun...",
        "feedback": "Anda harus memilih sebuah akun"
      },
      "platform": {
        "title": "Platform",
        "description": "Silakan pilih platform situs web Anda berdasarkan nama CMS.",
        "learn": "Pelajari cara memilihnya",
        "placeholder": "Cari platform berdasarkan nama CMS...",
        "info": {
          "title": "⚠ Platform ini baru ditambahkan.\n",
          "desc": "Platform pembuat situs web ini didukung oleh Linguise, meskipun baru saja ditambahkan. Jika Anda mengalami masalah, silakan hubungi kami melalui email dukungan langsung:"
        },
        "description_read_only": "Platform yang digunakan situs web Anda",
        "feedback": "Anda harus memilih sebuah platform"
      },
      "language": {
        "title": "Bahasa",
        "description": "Pilih bahasa dasar situs web Anda",
        "placeholder": "Pilih bahasa...",
        "feedback": "Anda harus memilih sebuah bahasa",
        "description_read_only": "Bahasa dasar situs web Anda"
      },
      "token": {
        "title": "Kunci API",
        "description": "Ini adalah Kunci API yang harus disalin ke situs web Anda",
        "copy": "Salin ke clipboard",
        "reset": "Reset Kunci API",
        "reset_confirm": "Silakan konfirmasi reset Kunci API"
      },
      "languages": {
        "title": "Bahasa terjemahan",
        "description": "Pilih bahasa yang Anda ingin situs web Anda dapat diterjemahkan ke dalamnya",
        "placeholder": "Pilih bahasa...",
        "feedback": "Anda harus memilih sebuah bahasa"
      },
      "defaultRules": {
        "title": "Aturan default",
        "description": "Kami telah mendefinisikan serangkaian aturan wajib gunakan untuk meningkatkan terjemahan dan menghindari konten yang tidak diinginkan diterjemahkan, seperti dasbor WordPress.\nAnda dapat menghapus atau mengedit aturan ini nanti jika diinginkan."
      },
      "disallow_deletion": "Anda tidak dapat menghapus domain dengan langganan aktif",
      "delete_confirm": "Silakan konfirmasi penghapusan domain",
      "delete": "Hapus domain",
      "dynamic": {
        "title": "Terjemahkan Konten Dinamis",
        "description": "Konten dinamis yang dihasilkan oleh JavaScript dan permintaan AJAX akan diterjemahkan (Opsi ini akan meningkatkan penggunaan terjemahan Anda)"
      },
      "partial_translations": {
        "title": "Izinkan Terjemahan Parsial",
        "description": "Jika akun Anda telah mencapai kuota terjemahan tetapi halaman masih membutuhkan terjemahan, Linguise dapat terus menampilkan halaman dengan konten yang sudah diterjemahkan.\nNamun, sebagian halaman akan tetap tidak diterjemahkan sampai Anda meningkatkan kuota Anda.\n\nMeskipun sedikit konten yang tidak diterjemahkan biasanya tidak merusak SEO, mengizinkan terlalu banyak konten yang tidak diterjemahkan dapat berdampak negatif pada pengalaman pengguna.\nUntuk mengatasinya, Anda dapat menetapkan ambang batas persentase konten yang tidak diterjemahkan yang diizinkan pada suatu halaman. Jika konten yang tidak diterjemahkan melebihi ambang batas ini, pengguna akan secara otomatis diarahkan ke versi bahasa asli halaman tersebut.",
        "never": "Tidak pernah"
      },
      "translate_error_pages": {
        "title": "Terjemahkan halaman error",
        "description": "Linguise dapat menerjemahkan semua halaman error, namun jika halaman error Anda berisi konten dinamis, seperti alamat IP atau ID permintaan, Anda sebaiknya menghindari menerjemahkan halaman tersebut.",
        "not_found_page": {
          "title": "Terjemahkan halaman 404"
        },
        "error_page": {
          "title": "Terjemahkan halaman error lainnya"
        }
      },
      "plugin_mode": {
        "modal": {
          "title": "Domain yang ada ditemukan",
          "description": "Sebuah domain yang ada telah ditemukan untuk pengguna ini, apakah Anda ingin menggunakannya?"
        }
      },
      "search_tl": {
        "title": "Cari Terjemahan",
        "description": "Aktifkan terjemahan pencarian untuk platform situs web Anda (Eksperimental, opsi ini akan meningkatkan penggunaan terjemahan Anda)"
      },
      "shopify_promo": {
        "info": "Berita bagus! Kami sekarang memiliki aplikasi integrasi Shopify yang dapat anda instal dari Shopify App Store",
        "hyperlink": "Klik di sini dan lakukan instalasi Linguise dari Shopify.",
        "next_btn": "Buka toko Shopify untuk menginstal aplikasi",
        "info_legacy": "Berita bagus! Kami sekarang memiliki aplikasi integrasi Shopify yang dapat anda instal dari Shopify App Store",
        "description_legacy": "Pilih platform \"Shopify\" bukan \"Shopify Legacy\""
      },
      "wix_promo": {
        "info": "Berita bagus! Kami sekarang memiliki aplikasi integrasi Wix yang dapat anda instal dari Wix App Market.",
        "hyperlink": "Klik di sini dan lakukan instalasi Linguise dari aplikasi.",
        "next_btn": "Buka Wix App Market untuk menginstal aplikasi",
        "info_legacy": "Berita bagus! Kami sekarang memiliki aplikasi integrasi Wix yang dapat anda instal dari Wix App Market.",
        "description_legacy": "Pilih platform \"Wix\" bukan \"Wix Legacy\""
      },
      "ai_disallow_deletion": "Anda tidak dapat menghapus domain ini selama kuota AI masih tersedia.\n\nSilakan hubungi tim dukungan kami jika Anda ingin menghapus domain ini di",
      "language_removal": {
        "card": {
          "title": "Hapus terjemahan bahasa yang dihapus",
          "description": "Bahasa ini telah dihapus dari situs web Anda, tetapi terjemahan tersimpannya masih dihitung dalam kuota. Hapus terjemahan tersebut untuk mengembalikan kata ke kuota.",
          "button": "Hapus terjemahan"
        },
        "hint": "Kata yang digunakan akan dikembalikan ke kuota Anda. Anda dapat melakukannya sekali setiap {{days}} hari untuk setiap situs web.",
        "modal": {
          "title": "Hapus terjemahan?",
          "intro": "Terjemahan ini akan dihapus secara permanen:",
          "warning": "Tindakan ini tidak dapat dibatalkan. Kata yang digunakan akan dikembalikan ke kuota Anda, dan prosesnya mungkin memerlukan beberapa menit.",
          "limit": "Anda dapat melakukannya sekali setiap {{days}} hari untuk setiap situs web.",
          "confirm": "Hapus terjemahan"
        },
        "scheduled": "Terjemahan sedang dihapus dan kuota Anda akan segera diperbarui.",
        "cooldown": "Terjemahan untuk situs web ini baru saja dihapus. Anda dapat menghapusnya lagi pada {{date}}.",
        "latest_completed": {
          "title": "Penghapusan terakhir yang selesai",
          "description": "Tinjau bahasa yang dihapus dan kata yang dikembalikan ke kuota Anda.",
          "languages": "Bahasa yang dihapus",
          "words_returned": "Kata yang dikembalikan ke kuota Anda: {{words}}",
          "completed_at": "Selesai pada {{date}}"
        },
        "status": {
          "recent_title": "Penghapusan terjemahan terbaru",
          "recent_description": "Pantau penghapusan terbaru dan lihat kapan penghapusan berikutnya tersedia.",
          "progress_title": "Progres penghapusan",
          "loading": "Memeriksa progres penghapusan...",
          "unavailable": "Progres penghapusan tidak dapat dimuat. Muat ulang halaman dan coba lagi.",
          "label": "Status",
          "pending": "Dalam antrean",
          "processing": "Sedang berlangsung",
          "completed": "Selesai",
          "failed": "Gagal",
          "unknown": "Status tidak tersedia",
          "percent": "{{percent}}% selesai",
          "current_stage": "Langkah saat ini: {{stage}}",
          "processed": "{{processed}} catatan diproses",
          "processed_total": "{{processed}} dari {{total}} catatan diproses",
          "requested_at": "Diminta {{date}}",
          "started_at": "Dimulai {{date}}",
          "completed_at": "Selesai pada {{date}}",
          "cooldown_period": "Anda dapat melakukannya sekali setiap {{days}} hari untuk setiap situs web.",
          "cooldown_blocked": "Penghapusan lain belum dapat dimulai.",
          "stage": {
            "queued": "Menunggu untuk dimulai",
            "processing": "Sedang berlangsung",
            "refund_summary": "Menghitung kata yang dikembalikan",
            "search_translations": "Menghapus terjemahan pencarian",
            "url_translations": "Menghapus terjemahan URL",
            "translations": "Menghapus terjemahan",
            "completed": "Selesai",
            "failed": "Gagal",
            "unknown": "Sedang berlangsung"
          }
        },
        "forbidden": "Anda tidak memiliki izin untuk menghapus terjemahan."
      }
    },
    "main": {
      "edit": "Ubah domain",
      "add": "Tambah domain",
      "wizard": "Selamat datang! Panduan pembuatan domain baru",
      "common": "Domain"
    },
    "notice": {
      "broken_card": "Kami tidak dapat memperpanjang paket Anda untuk {{url}} menggunakan metode pembayaran saat ini, silakan perbarui kartu pembayaran Anda",
      "quota_reached": "Kuota terjemahan Anda untuk {{url}} telah tercapai, silakan upgrade untuk melanjutkan terjemahan situs web Anda",
      "ai_no_subscription": "Terjemahan AI untuk {{url}} memerlukan langganan aktif atau trial aktif. Itu akan berhenti tanpa satu, silakan upgrade untuk melanjutkan",
      "important": "Penting",
      "quota_reached_button": "Tingkatkan paket Anda sekarang",
      "broken_card_button": "Perbarui kartu pembayaran Anda",
      "ai_no_subscription_button": "Tingkatkan paket Anda sekarang",
      "quota_warning": "Kuota terjemahan Anda untuk {{url}} telah mencapai {{throttling_used_percent}}%, ini akan direset dalam {{ttl}}",
      "locked": "Domain {{url}} saat ini dikunci untuk migrasi, Anda masih dapat mengakses situs Anda tetapi tidak dapat mengedit atau menambahkan terjemahan baru!"
    },
    "subdomains": {
      "config_ok": "DNS Subdomain telah dikonfigurasi dengan benar.",
      "config_invalid": "DNS Subdomain memerlukan konfigurasi tambahan agar berfungsi.",
      "config_check": "Konfigurasi DNS Subdomain sedang diperiksa, harap tunggu...",
      "entri_timeout": "Entri melaporkan proses propagasi DNS Subdomain Anda telah habis waktu, Anda harus mencoba lagi atau dapat melakukannya secara manual.",
      "entri_process": "DNS Anda telah ditambahkan dengan Entri dan biasanya memerlukan 10-30 menit untuk propagasi (menerapkan semua subdomain bahasa Anda seperti es.domain.com). Jika validasi DNS tidak selesai setelah 24 jam, Anda dapat menghubungi tim dukungan kami: support@linguise.com",
      "entri_ok": "Propagasi DNS sedang berlangsung! Menunggu propagasi...",
      "infos": "Anda harus menambahkan entri DNS ini ke catatan domain DNS Anda untuk mengaktifkan terjemahan. Klik tombol centang setelah selesai. Ada kemungkinan catatan DNS membutuhkan waktu untuk disebarkan, jadi Anda mungkin perlu kembali setelah beberapa menit atau jam.",
      "check": "Periksa konfigurasi DNS"
    },
    "subscription": {
      "next_payment_amount": "Biaya yang akan datang",
      "next_payment_date": "Tanggal pembayaran berikutnya",
      "invoice": {
        "header": "Riwayat faktur",
        "date": "Tanggal",
        "amount_due": "Jumlah",
        "status": "Status",
        "actions": "Tindakan",
        "description": "Setelah transaksi tersedia, Anda dapat melihatnya di sini.",
        "status_text": {
          "draft": "Draf",
          "failed": "Gagal",
          "open": "Menunggu",
          "paid": "Dibayar",
          "retrying": "Mencoba lagi",
          "uncollectible": "Tidak dapat ditagih",
          "void": "Batal"
        },
        "view": "Lihat",
        "empty": "Tidak ada faktur terbaru untuk langganan ini",
        "retry_payment": "Coba lagi"
      },
      "next_cancellation": "Tanggal pembatalan",
      "cancel": "Batalkan langganan",
      "change_plan": "Ubah paket",
      "change": "Ubah",
      "suspend": "Tangguhkan pembayaran",
      "resume": "Lanjutkan langganan",
      "back": "Kembali",
      "save": "Simpan",
      "confirm_resume": "Apakah Anda yakin ingin melanjutkan langganan ini?",
      "confirm_cancel": "Apakah Anda yakin ingin membatalkan langganan ini?",
      "confirm_header": "Apakah Anda yakin?",
      "missing_status": "Langganan ini tidak memiliki status",
      "not_found": "Tidak ditemukan langganan untuk domain ini",
      "confirm_manual_retry": "Apakah Anda yakin ingin mencoba kembali pembayaran ini?",
      "no_payment_method": "Tidak diketahui",
      "remove_billing": "Hapus",
      "shopify_maneged": "Langganan ini dikelola oleh Shopify. Silakan kelola dari panel admin Shopify Anda.",
      "unknown_plan": "Paket tidak diketahui"
    }
  },
  "domain_listing": {
    "add": "Tambah situs web",
    "select": "Pilih domain"
  },
  "editable": {
    "number": "nomor {{id}}"
  },
  "footer": {
    "about": "Tentang",
    "support": "Dukungan"
  },
  "frontendEditor": {
    "main": "Editor antarmuka",
    "description": "Editor antarmuka membantu anda mengedit terjemahan secara langsung di situs web Anda.",
    "button": "Buka editor antarmuka",
    "language_selection": "Pemilihan bahasa terjemahan",
    "video_label": "Pelajari cara menggunakan editor antarmuka"
  },
  "general": {
    "403": {
      "tab_title": "Ooops - Kesalahan 403",
      "title": "Akses ditolak",
      "message": "Sepertinya Anda tidak memiliki akses ke halaman yang diminta.",
      "home": "Kembali ke Beranda"
    },
    "404": {
      "tab_title": "Ooops - Kesalahan 404",
      "title": "Halaman Tidak Ditemukan",
      "message": "Sepertinya Anda mengambil jalan yang salah. Jangan khawatir... hal ini terjadi pada siapa saja. Berikut tip kecil yang mungkin membantu Anda kembali ke jalur yang benar.",
      "home": "Kembali ke Beranda"
    },
    "500": {
      "tab_title": "Kesalahan 500",
      "title": "Kesalahan Server Internal",
      "message": "Coba segarkan halaman Anda? atau Anda dapat menghubungi kami",
      "home": "Kembali ke Beranda"
    },
    "fields": {
      "alert": "Beberapa bidang tidak valid, silakan perbaiki bidang yang tidak valid.",
      "invalid": "Bidang ini tidak valid",
      "phone_re": "Nomor telepon tidak valid",
      "phone_invalid": "Nomor telepon tidak valid",
      "email": "Kolom email tidak valid"
    },
    "table": {
      "no_data": "Belum ada data di sini..."
    },
    "saving": "Menyimpan ...",
    "save": "Simpan",
    "save_and_quit": "Simpan & Keluar",
    "invite": "Undang",
    "cancel": "Batal",
    "yes": "Ya",
    "no": "Tidak",
    "nextStep": "Langkah berikutnya",
    "loading": "Harap tunggu, aplikasi sedang dimuat",
    "goback": "Kembali",
    "manage": "Kelola",
    "delete": "Hapus",
    "deleting": "Menghapus ...",
    "confirm": "Konfirmasi",
    "unknown": "Tidak diketahui",
    "hide": "Bersembunyi",
    "show": "Menunjukkan",
    "on": "Pada",
    "off": "Mati",
    "default": "Default"
  },
  "home": {
    "header": "Beranda",
    "manage": "Kelola langganan",
    "canceled": "Dijadwalkan untuk pembatalan",
    "activate_now": "Aktifkan sekarang",
    "activate_plan_now": "Berlangganan sekarang",
    "upgrade_plan_now": "Tingkatkan paket sekarang",
    "trial_message_part_1": "Anda saat ini berada pada paket percobaan, ",
    "trial_message_part_2": "Anda dapat mengaktifkan keanggotaan kapan saja.",
    "add": "Tambah domain",
    "table": {
      "title": "Domain",
      "description": "Daftar domain Anda, klik pada domain untuk mengelola terjemahan"
    },
    "domains": {
      "empty": "Anda tidak memiliki domain di akun ini"
    },
    "accountsList": {
      "title": "Akun",
      "add": "Tambah akun baru",
      "name": "Nama akun"
    },
    "update_credit_card": "Perbarui detail kartu kredit",
    "cancelling_subs": "Membatalkan pada {{0}}",
    "resume_subscription": "Lanjutkan langganan",
    "shopify_managed": "Dikelola oleh Shopify",
    "trial_ends_at": "Berakhir pada {{0}}",
    "free_trial": "Uji coba gratis",
    "no_subs": "Tidak ada langganan aktif"
  },
  "invoices": {
    "title": "Faktur",
    "list": {
      "title": "Daftar faktur"
    },
    "table": {
      "customer": "Pelanggan",
      "domain": "Domain",
      "amountPaid": "Jumlah Dibayar",
      "status": "Status",
      "date": "Tanggal",
      "invoice": "Faktur",
      "pay": "Bayar faktur",
      "actions": "Tindakan",
      "deleted_domain": "Domain dihapus",
      "plan_name": "Paket",
      "action": "Aksi"
    },
    "listPending": {
      "title": "Daftar faktur tertunda"
    }
  },
  "language_settings": {
    "display": "Tampilan daftar bahasa",
    "position": "Posisi",
    "display_help_text": "Tampilkan bendera dan/atau nama bahasa. Posisi default pengalih bahasa dapat berada di mana saja dalam konten atau di posisi tetap yang tetap atau bergerak saat menggulir",
    "side_by_side": "Bersebelahan",
    "dropdown": "Menu tarik-turun",
    "popup": "Pop-up",
    "flag": "Bendera",
    "lang_name": "Nama bahasa",
    "lang_short_name": "Nama pendek",
    "positions": {
      "in_place": "Di tempat",
      "top_left": "Kiri atas",
      "top_left_no_scroll": "Kiri atas (tanpa gulir)",
      "top_right": "Kanan atas",
      "top_right_no_scroll": " Kanan atas (tanpa gulir)",
      "bottom_left": "Kiri bawah",
      "bottom_left_no_scroll": "Kiri bawah (tanpa gulir)",
      "bottom_right": "Kanan bawah",
      "bottom_right_no_scroll": "Kanan bawah (tanpa gulir)"
    },
    "lang_names_display": {
      "title": "Tampilan nama bahasa",
      "help_text": "Di pengalih bahasa, tampilkan nama bahasa dalam Bahasa Inggris atau dalam bahasa aslinya, misalnya French atau Français",
      "english": "Inggris",
      "native_languages": "Bahasa Asli"
    },
    "flag_shape": {
      "title": "Gaya bendera",
      "help_text": "Gunakan ikon bendera svg bulat atau persegi panjang",
      "round": "Bulat",
      "rectangular": "Persegi panjang"
    },
    "english_flag_type": {
      "title": "Jenis bendera Inggris",
      "help_text": "Gunakan bendera Britania Raya atau USA untuk bahasa Inggris",
      "usa": "Bendera USA",
      "great_britain": "Bendera Britania Raya"
    },
    "german_flag_type": {
      "title": "Jenis bendera Jerman",
      "help_text": "Gunakan bendera Austria atau Jerman untuk bahasa Jerman",
      "german": "Bendera Jerman",
      "austria": "Bendera Austria"
    },
    "spain_flag_type": {
      "title": "Jenis bendera Spanyol",
      "help_text": "Gunakan bendera Meksiko atau Spanyol untuk bahasa Spanyol",
      "spanish": "Bendera Spanyol",
      "mexico": "Bendera Meksiko",
      "peruvian": "Bendera Peru"
    },
    "portugal_flag_type": {
      "title": "Jenis bendera Portugis",
      "help_text": "Gunakan bendera Portugal atau Brasil untuk bahasa Portugis",
      "portugal": "Bendera Portugal",
      "brazil": "Bendera Brasil"
    },
    "taiwanese_flag_type": {
      "title": "Jenis bendera Taiwan",
      "help_text": "Gunakan bendera Taiwan atau China untuk bahasa Taiwan",
      "taiwanese": "Bendera Taiwan",
      "chinese": "Bendera China"
    },
    "flag_border_radius": {
      "title": "Radius batas bendera (px)",
      "help_text": "Jika Anda menggunakan bentuk bendera persegi panjang, Anda dapat menerapkan radius batas khusus dalam piksel"
    },
    "flag_width": {
      "title": "Ukuran bendera (px)",
      "help_text": "Pilih ukuran bendera dalam piksel. Itu tidak mengubah berat gambar karena format .svg"
    },
    "lang_color": {
      "color_title": "Warna nama bahasa",
      "color_help_text": "Pilih warna teks default untuk nama bahasa Anda",
      "hover_color_title": "Warna hover nama bahasa",
      "hover_color_help_text": "Pilih warna teks hover mouse untuk nama bahasa Anda",
      "color_popup_title": "Warna bahasa popup",
      "color_popup_help_text": "Warna judul bahasa di area popup atau dropdown",
      "hover_color_popup_title": "Warna hover bahasa popup",
      "hover_color_popup_help_text": "Pilih warna teks hover mouse untuk judul bahasa di area popup atau dropdown"
    },
    "flag_box_shadow": {
      "shadow_title": "Bayangan kotak bendera",
      "shadow_help_text": "Warna dan ukuran bayangan untuk bendera bahasa Anda",
      "hover_shadow_title": "Bayangan kotak bendera saat hover",
      "hover_shadow_help_text": "Warna dan ukuran bayangan untuk bendera bahasa Anda saat hover mouse",
      "shadow_h_offset": "Offset H bayangan (px)",
      "shadow_v_offset": "Offset V bayangan (px)",
      "shadow_blur": "Blur bayangan (px)",
      "shadow_spread": "Sebaran bayangan (px)",
      "shadow_color": "Warna bayangan"
    },
    "order": "Urutan bahasa",
    "language_order_help": "Urutan bahasa yang akan ditampilkan di pengalih bahasa. Anda dapat menyeret dan menjatuhkan bahasa untuk mengatur ulang mereka.",
    "order_reset": "Reset urutan",
    "language_order_dragdrop": "Anda dapat menyeret dan menjatuhkan bahasa untuk mengatur ulang mereka.",
    "popup_lang_name": "Nama Bahasa Popup",
    "preview": "Pratinjau bahasa"
  },
  "link": {
    "form": {
      "original": {
        "title": "Sumber Asli",
        "description": "Tambahkan URL tautan asli Anda dan ganti di bawahnya menurut bahasa untuk menerjemahkannya",
        "srcset_description": "Anda sedang mengedit URL gambar. Pastikan membaca dokumentasi, terutama jika Anda menggunakan srcset, atau tidak tahu apa itu",
        "link": "Tautan",
        "match_link": "Mode cocok",
        "match_exact": "Tepat",
        "match_wildcard": "Karakter pengganti",
        "match_regex": "Ekspresi reguler"
      },
      "alternative_languages": {
        "title": "Link yang akan diganti",
        "description": "Ganti tautan media dan tautan eksternal di seluruh halaman Anda, berdasarkan bahasa…",
        "link": "Tautan yang akan diganti"
      },
      "error": {
        "atLeastOne": "Harap tambahkan setidaknya satu terjemahan.",
        "url": "URL tidak valid",
        "extension": "Tautan harus memiliki ekstensi, tetapi tidak boleh .html atau .php. Dan tautan tidak boleh mengandung jalur bahasa misalnya \"/fr\"",
        "regex": "Regex tidak valid",
        "wildcard": "Tautan wildcard memiliki protokol yang tidak valid"
      }
    },
    "main": {
      "parent": "Tautan",
      "edit": "Edit tautan"
    }
  },
  "links": {
    "title": "Manajemen tautan media dan eksternal",
    "description": "Daftar dan edit tautan Media atau tautan eksternal situs web Anda.",
    "add": "Tambah Tautan",
    "delete": "Hapus Tautan",
    "table": {
      "original": "Asli",
      "language": "Bahasa",
      "translation": "Terjemahan",
      "action": "Aksi",
      "delete_confirm": "Harap konfirmasi penghapusan tautan"
    }
  },
  "members": {
    "header": "Anggota",
    "invite": "Undang anggota baru",
    "modal": {
      "inviteHeader": "Undang anggota baru",
      "editHeader": "Edit anggota",
      "detachHeader": "Lepaskan anggota",
      "detachBody": "Apakah Anda yakin ingin melepaskan anggota dari akun ini?",
      "selfDetachBody": "Apakah Anda yakin ingin melepaskan diri Anda dari pengelolaan akun ini? Setelah itu, Anda tidak akan dapat mengakses data apa pun yang terkait dengan akun ini."
    },
    "table": {
      "title": "Daftar Anggota",
      "description": "Peran anggota dan akses domain",
      "name": "Nama",
      "email": "Email",
      "websites": "Situs Web",
      "languages": "Bahasa",
      "role": "Peran",
      "status": "Status",
      "resendInvite": "kirim ulang",
      "inviteSent": "undangan telah dikirim",
      "actions": "Aksi",
      "edit": "Ubah",
      "detach": "Lepaskan",
      "empty": "Anda belum memiliki anggota",
      "all_website": "Semua situs web dan bahasa",
      "roles": {
        "admin": "Admin",
        "manager": "Manajer",
        "translator": "Penerjemah"
      },
      "statuses": {
        "pending": "Menunggu",
        "accepted": "Diterima",
        "declined": "Ditolak"
      }
    },
    "errors": {
      "role": "Anda harus memilih peran",
      "domains": "Anda harus memilih setidaknya 1 situs web untuk peran yang dipilih",
      "languages": "Anda harus memilih setidaknya 1 bahasa untuk situs web yang dipilih"
    },
    "inviteSent": "Undangan Anda telah berhasil dikirim"
  },
  "pagination": {
    "showing": "Menampilkan {{limit}} dari {{total}} hasil",
    "showing_only_count": "Menampilkan {{limit}} hasil"
  },
  "payments_method": {
    "header": "Metode Pembayaran",
    "table": {
      "title": "Daftar metode pembayaran",
      "description": "Metode pembayaran yang terhubung ke akun Anda",
      "default": "Bawaan",
      "action_edit_remove": "Edit atau hapus",
      "action_remove": "Hapus",
      "action_default": "Jadikan default",
      "action_fallback": "Jadikan fallback",
      "expires": "Kadaluarsa",
      "add_new_card": "Tambah metode pembayaran",
      "action_fallback_remove": "Hapus dari fallback",
      "fallback": "Cadangan",
      "action_edit": "Ubah",
      "action_delete": "Hapus",
      "action_default_remove": "Hapus sebagai Default",
      "domain_count@@one": "Digunakan oleh {{count}} domain",
      "domain_count@@other": "Digunakan oleh {{count}} domain"
    },
    "paypal_bind": {
      "button": "Hubungkan Akun PayPal",
      "button_load": "Menyambungkan...",
      "disconnected": "Tidak terhubung",
      "success": "Akun PayPal Anda sekarang terhubung, $5 akan dipotong dari faktur berikutnya!",
      "success_no_promo": "Akun PayPal Anda sekarang terhubung",
      "error": "Terjadi kesalahan",
      "success_header": "Berhasil"
    },
    "card_add": {
      "header": "Tambah kartu baru",
      "success": "Kartu baru terhubung ke Linguise!",
      "terms": "Dengan memberikan informasi kartu Anda, Anda mengizinkan Linguise menagih kartu Anda untuk pembayaran di masa depan sesuai ketentuan layanan kami."
    },
    "card_detail": {
      "header": "Info Kartu",
      "delete": {
        "error": "Anda tidak dapat menghapus metode pembayaran ini karena memiliki langganan aktif!"
      }
    },
    "subscriptions": {
      "table": {
        "description": "Langganan pada metode pembayaran ini",
        "header_domain": "Domain",
        "header_plan": "Paket",
        "header_status": "Status",
        "header_actions": "Aksi",
        "cancelling": "Membatalkan pada: {{0}}",
        "next_payment": "Pembayaran berikutnya pada: {{0}}",
        "action_renew": "Perpanjang",
        "no_subs_header": "Tidak ada langganan untuk ditampilkan",
        "no_subs_desc": "Setelah sebuah langganan dibuat dengan kartu ini, semua informasi akan ditampilkan di sini",
        "action_manage": "Kelola"
      },
      "status": {
        "active": "Aktif",
        "canceled": "Dibatalkan",
        "incomplete": "Belum dibayar",
        "incomplete_expired": "Belum dibayar (Kadaluarsa)",
        "missing": "Kesalahan",
        "past_due": "Terlambat",
        "trialing": "Percobaan",
        "unpaid": "Belum dibayar"
      }
    },
    "delete_confirm_body": "Apakah Anda yakin ingin menghapus metode pembayaran ini? Aksi ini tidak dapat dibatalkan!",
    "delete_confirm_header": "Hapus metode pembayaran?",
    "card_edit": {
      "header": "Edit kartu",
      "billing_header": "Informasi penagihan",
      "address_error": "Alamat diperlukan!",
      "card_number": "Nomor kartu",
      "card_expiry": "Tanggal kedaluwarsa",
      "expiry_error_month": "Bulan yang diberikan tidak valid",
      "expiry_error_year": "Tahun yang diberikan tidak valid",
      "expiry_error_expired": "Tahun kedaluwarsa kartu Anda berada di masa lalu.",
      "card_header": "Informasi kartu",
      "expiry_error_empty": "Kolom ini wajib diisi!"
    }
  },
  "plans": {
    "per": "per",
    "wordsTranslated": "kata diterjemahkan",
    "current": "Saat ini",
    "archived": "Diarsipkan",
    "day": "hari",
    "week": "minggu",
    "month": "bulan",
    "year": "tahun",
    "activate": "Aktifkan",
    "cancel": "Batalkan",
    "change": "Ubah",
    "upgrade": "Tingkatkan",
    "downgrade": "Turunkan",
    "resume": "Lanjutkan",
    "notEnoughWords": "Kata tidak cukup",
    "yearIntervalOnly": "Tidak dapat migrasi dari paket tahunan",
    "subsCanceled": "Ada pembatalan langganan lain yang sedang diproses",
    "wordsUnlimited": "Kata tak terbatas",
    "tabs": {
      "day": "Harga harian",
      "week": "Harga mingguan",
      "month": "Harga bulanan",
      "year": "Harga tahunan",
      "sub_texts": {
        "day": "Satu harga tetap, setiap hari",
        "week": "Satu harga tetap, setiap minggu",
        "month": "Satu harga tetap, setiap bulan",
        "year": "Satu bulan gratis, satu tagihan per tahun"
      }
    },
    "details": {
      "new_languages": "Tambahkan bahasa baru kapan saja",
      "one_month_trial": "Uji coba gratis satu bulan untuk setiap situs web baru",
      "multi_content_indexed": "100% konten multibahasa terindeks",
      "translate_new_content": "Terjemahkan konten baru secara instan",
      "free_installation": "Instalasi dan penyiapan gratis",
      "compared_monthly_plan": "Satu bulan gratis dibandingkan paket bulanan",
      "risk_free_recurring": "Pembayaran berulang bebas risiko",
      "unlimited_languages": "Bahasa & tampilan halaman tak terbatas",
      "high_server_resources": "Sumber daya server tinggi",
      "billed": {
        "day": "Ditagih harian",
        "week": "Ditagih mingguan",
        "month": "Ditagih bulanan",
        "year": "Ditagih tahunan"
      },
      "request_max_size": "{{0}} ukuran maksimum permintaan"
    },
    "frequent_question": {
      "title": "Pertanyaan umum",
      "questions": {
        "trial": {
          "question": "Apakah saya dapat menggunakan uji coba pada domain situs web baru?",
          "answer": "Ya, kami menawarkan uji coba gratis 30 hari untuk setiap domain situs web baru yang Anda tambahkan ke akun Anda. Dengan cara ini, Anda dapat menguji layanan terjemahan sepenuhnya pada situs web baru Anda."
        },
        "seo": {
          "question": "Berapa lama waktu yang diperlukan agar SEO saya meningkat?",
          "answer": "Konten, terutama konten multibahasa, membutuhkan waktu untuk terindeks sepenuhnya dan mendapatkan peringkat yang baik. Tergantung pada lalu lintas dan ukuran situs web Anda, biasanya antara 3 hingga 6 minggu."
        },
        "quota": {
          "question": "Apakah terjemahan manusia termasuk dalam kuota?",
          "answer": "Tidak, batas jumlah kata hanya berlaku untuk terjemahan mesin otomatis. Penerjemah dapat mengedit terjemahan otomatis secara manual tanpa batas."
        }
      }
    },
    "best_offer": "Penawaran terbaik",
    "period": {
      "days@@one": "hari",
      "days@@other": "{{count}} hari",
      "hours@@one": "jam",
      "hours@@other": "{{count}} jam",
      "minutes@@one": "menit",
      "minutes@@other": "{{count}} menit",
      "seconds@@one": "detik",
      "seconds@@other": "{{count}} detik"
    },
    "words": {
      "billion": "{{value}}B",
      "million": "{{value}}M",
      "thousand": "{{value}}K"
    },
    "throttling_info": "{{words}} kata per {{period}}"
  },
  "profile": {
    "welcome": "Selamat datang!",
    "account": "Akun Saya",
    "subscriptions": "Langganan",
    "logout": "Keluar"
  },
  "register": {
    "errors": {
      "password": "Minimal 8 karakter, karakter apa saja"
    }
  },
  "route": {
    "dashboard": "Dasbor",
    "rules": "Aturan",
    "translations": "Terjemahan",
    "search_translations": "Pencarian Kuery",
    "urls_translations": "Terjemahan URL",
    "links": "Media dan tautan eksternal",
    "online_editor": "Editor Antarmuka",
    "settings": "Pengaturan",
    "domain": {
      "finish": "Pengaturan",
      "preconfig": "Pengaturan"
    },
    "home": "Beranda",
    "domain_list": "Daftar domain",
    "members": "Anggota",
    "invoices": "Faktur",
    "billing": "Detail penagihan",
    "language_display": "Tampilan bendera bahasa",
    "payment_methods": "Metode Pembayaran",
    "ai_translation": "Terjemahan AI",
    "ai_translation_settings": "Pengaturan",
    "ai_translation_pricing": "Harga"
  },
  "rule": {
    "form": {
      "text_ignore": {
        "placeholder": "Teks yang diabaikan",
        "add": "Tambah baru",
        "title": "Teks yang diabaikan",
        "description": "Tambahkan satu atau beberapa teks untuk diabaikan",
        "ignore_case": "Abaikan huruf besar/kecil"
      },
      "html_content": {
        "title": "Terapkan pada konten HTML",
        "description": "Terapkan aturan di seluruh konten Anda atau dengan memilih selector CSS spesifik",
        "all_page": "Seluruh halaman",
        "css_selector": "Selector CSS",
        "label": "Selector CSS",
        "placeholder": "Selector untuk diterapkan",
        "add": "Tambah baru"
      },
      "apply_to_urls": {
        "title": "Terapkan pada URL",
        "description": "Pilih URL spesifik tempat Anda ingin aturan diterapkan",
        "all_urls": "Semua URL",
        "selected_urls": "URL Terpilih",
        "label": "URL untuk diterapkan",
        "placeholder": "URL untuk diterapkan",
        "original_url": "URL Asli",
        "translated_url": "URL Terjemahan",
        "wildcard": "Karakter pengganti",
        "regex": "Ekspresi reguler",
        "add": "Tambah baru",
        "expression": "Tipe Ekspresi"
      },
      "apply_urls": {
        "title_exclude": "Kecualikan di URL",
        "title_replace": "Ganti di URL",
        "title_description": "Juga terapkan aturan ini pada terjemahan URL"
      },
      "apply_languages": {
        "title": "Terapkan pada bahasa",
        "description": "Pilih bahasa spesifik tempat Anda ingin aturan diterapkan",
        "all_languages": "Semua bahasa",
        "selected_languages": "Bahasa terpilih",
        "placeholder": "Pilih bahasa...",
        "feedback": "Anda harus memilih bahasa"
      },
      "name": {
        "title": "Judul",
        "description": "Berikan judul pada aturan Anda untuk memudahkan",
        "placeholder": "Nama aturan"
      },
      "type": {
        "title": "Tipe",
        "description": "Pilih tipe aturan yang ingin Anda tambahkan",
        "text_ignore": "Abaikan teks",
        "text_replace": "Ganti teks",
        "content_exclusion": "Pengecualian konten",
        "url_exclusion": "Pengecualian berdasarkan URL",
        "ignore_inline": "Abaikan inline",
        "full_description": {
          "text_ignore": "Tambahkan aturan untuk menghindari beberapa teks diterjemahkan. Bisa berupa nama produk, merek, atau elemen teknis lain yang tidak ingin diterjemahkan.",
          "text_replace": "Ganti teks memungkinkan mengganti beberapa teks dengan terjemahan yang Anda inginkan, diperlukan ketika terjemahan mengabaikan konteks.",
          "content_exclusion": "Pengecualian konten akan membantu Anda menghindari terjemahan pada sebagian konten di halaman.\nJika Anda ingin sepenuhnya mengecualikan halaman dari terjemahan (tidak ada URL multibahasa sama sekali untuk halaman ini dan tidak ada konten terjemahan) gunakan tipe \"Pengecualian berdasarkan URL\"",
          "url_exclusion": "Pengecualian terjemahan halaman akan membantu Anda menentukan halaman yang tidak ingin diterjemahkan.",
          "ignore_inline": "Hindari menerjemahkan beberapa konten sebagai konten inline, terjemahkan setiap tag secara terpisah sebagai gantinya."
        }
      },
      "text_replace": {
        "title": "Teks untuk diganti",
        "description": "Ganti beberapa teks dengan terjemahan spesifik Anda. Ganti teks apa pun di seluruh halaman, berdasarkan bahasa…",
        "text_to_replace": "Teks untuk diganti",
        "ignore_case": "Abaikan huruf besar/kecil",
        "text_type": "Penggantian dalam terjemahan",
        "text_type_original": "Asli",
        "text_type_translation": "Terjemahan",
        "keep_case": "Coba pertahankan kapitalisasi",
        "add": "Tambah baru"
      },
      "content_exclusion": {
        "title": "Pengecualian konten",
        "description": "Pilih satu atau lebih selector CSS yang tidak akan diterjemahkan",
        "label": "Selector CSS",
        "placeholder": "Selector untuk diterapkan",
        "add": "Tambah baru"
      },
      "multilingual_url": {
        "title": "Gunakan URL multibahasa",
        "description": "Jika disetel Ya, URL tidak akan diterjemahkan tetapi halaman tetap multibahasa dengan konten terjemahan",
        "live_example_title": "Contoh langsung",
        "live_example_description": "URL sumber: https://yourwebsite.com/page-not-translated",
        "live_example_multilingual": "URL terhasil: https://yourwebsite.com/fr/page-not-translated",
        "live_example_no_multilingual": "URL terhasil: https://yourwebsite.com/page-not-translated"
      },
      "rule_application": {
        "description": "Terapkan aturan pada konten statis atau dinamis atau keduanya",
        "title": "Terapkan pada konten",
        "all": "Semua konten",
        "static": "Konten statis",
        "dynamic": "Konten dinamis"
      },
      "force_apply_urls": {
        "title_description": "Paksa terapkan aturan ini pada semua terjemahan URL, termasuk terjemahan yang ada!",
        "title_replace": "Paksa ganti di URL",
        "title_exclude": "Paksa kecualikan di URL",
        "warning": "Peringatan",
        "warning_part1": "Mengatur ini ke \"Ya\" dapat merusak terjemahan URL situs Anda.",
        "warning_part2": "Ini dapat sementara atau permanen menghasilkan halaman 404, lanjutkan hanya jika Anda memahami konsekuensinya.",
        "warning_replacement_original": "Peringatan tambahan: Anda mencoba mengganti konten asli yang dapat memengaruhi URL, terjemahan mungkin gagal karena Linguise tidak dapat menemukan URL asli dengan tepat"
      }
    },
    "main": {
      "parent": "Aturan",
      "edit": "Edit aturan",
      "add": "Aturan baru"
    }
  },
  "rules": {
    "text_ignore": {
      "preview_single_with_url": "\"{{text_ignore}}\" akan diabaikan dalam konten dan di URL",
      "preview_single": "\"{{text_ignore}}\" akan diabaikan dalam konten",
      "preview_more_with_url": "\"{{text_ignore}}\" dan {{count}} lainnya akan diabaikan dalam konten",
      "preview_more": "\"{{text_ignore}}\" dan {{count}} lainnya akan diabaikan dalam konten",
      "other_parameters": "Parameter lain telah diatur untuk aturan ini, klik tombol edit untuk informasi lebih lanjut"
    },
    "text_replace": {
      "preview_single_with_url": "\"{{original}}\" diganti dengan \"{{replacement}}\" dalam konten dan URL",
      "preview_single": "\"{{original}}\" diganti dengan \"{{replacement}}\" dalam konten",
      "preview_more_with_url": "\"{{original}}\" diganti dengan \"{{replacement}}\" dalam konten dan URL, dan {{nb}} lainnya",
      "preview_more": "\"{{original}}\" diganti dengan \"{{replacement}}\" dalam konten, dan {{nb}} lainnya",
      "other_parameters": "Parameter lain telah diatur untuk aturan ini, klik tombol edit untuk informasi lebih lanjut"
    },
    "content_exclusion": {
      "selectors": "{{nb}} selector CSS dikecualikan dari terjemahan",
      "other_parameters": "Parameter lain telah diatur untuk aturan ini, klik tombol edit untuk informasi lebih lanjut"
    },
    "url_exclusion": {
      "some_multilingual": "{{nb}} URL dikecualikan dari terjemahan, tetapi tetap mempertahankan prefiks multibahasa",
      "some": "{{nb}} URL sepenuhnya dikecualikan dari terjemahan",
      "all_multilingual": "semua URL dikecualikan dari terjemahan, tetapi tetap mempertahankan prefiks multibahasa",
      "all": "semua URL sepenuhnya dikecualikan dari terjemahan",
      "other_parameters": "Parameter lain telah diatur untuk aturan ini, klik tombol edit untuk informasi lebih lanjut"
    },
    "ignore_inline": {
      "elements": "Semua konten inline akan diterjemahkan sebagai blok di halaman",
      "all_elements": "Beberapa konten inline akan diterjemahkan sebagai blok di halaman",
      "other_parameters": "Parameter lain telah ditetapkan untuk aturan ini, klik tombol edit untuk mendapatkan informasi lebih lanjut."
    },
    "title": "Manajemen Aturan",
    "description": "Kelola pengecualian dan penggantian konten terjemahan di seluruh situs web Anda",
    "add": "Tambah aturan baru",
    "table": {
      "title": "Judul",
      "no_data": "Belum ada aturan",
      "type": "Tipe",
      "preview": "Pratinjau aturan",
      "action": "Aksi",
      "delete_confirm": "Harap konfirmasi penghapusan aturan",
      "types": {
        "text_ignore": "Abaikan teks",
        "text_replace": "Ganti teks",
        "content_exclusion": "Pengecualian konten",
        "url_exclusion": "Pengecualian URL",
        "ignore_inline": "Abaikan inline",
        "unknown": "Aturan tidak diketahui"
      }
    },
    "apply_on_content": {
      "static": "Aturan ini hanya akan diterapkan pada konten statis.",
      "dynamic": "Aturan ini hanya akan diterapkan pada konten dinamis."
    }
  },
  "search_translations": {
    "title": "Manajemen kueri pencarian",
    "description": "Daftar semua terjemahan situs web Anda yang digunakan melalui formulir pencarian (Dari bahasa terjemahan ke bahasa dasar domain Anda)",
    "filter_languages": "Filter berdasarkan bahasa...",
    "filter_original": "Filter teks dalam bahasa asli",
    "filter_translation": "Filter berdasarkan teks terjemahan",
    "table": {
      "original": "Asli",
      "language": "Bahasa",
      "translation": "Terjemahan"
    }
  },
  "subscription": {
    "failure": {
      "tab_title": "Gagal berlangganan!",
      "title": "Gagal berlangganan!",
      "subtitle": "Terjadi kesalahan saat mencoba memproses langganan Anda.",
      "home": "Kembali ke beranda",
      "generic": "Terjadi kesalahan tidak diketahui di sisi Linguise, silakan hubungi administrator!"
    },
    "success": {
      "home": "Kelola terjemahan domain",
      "message": "Kami berkomitmen untuk memberikan pengalaman terjemahan terbaik. Tim ahli kami siap membantu Anda dengan pertanyaan atau dukungan apa pun yang Anda perlukan. Untuk memulai, cukup klik tombol di bawah ini.",
      "subtitle": "Terima kasih telah memilih layanan terjemahan Linguise",
      "title": "Langganan diaktifkan!",
      "tab_title": "Terima kasih atas langganan!"
    }
  },
  "subscriptions": {
    "success": {
      "tab_title": "Langganan diaktifkan!",
      "title": "Langganan diaktifkan!",
      "subtitle": "Terima kasih telah memilih layanan terjemahan Linguise",
      "message": "'Kami berkomitmen untuk memberikan pengalaman terjemahan terbaik. Tim ahli kami siap membantu Anda dengan pertanyaan atau dukungan apa pun yang Anda perlukan. Untuk memulai, cukup klik tombol di bawah ini. ",
      "home": "Kelola terjemahan domain"
    },
    "edit": {
      "title": "Kelola langganan"
    },
    "list": {
      "title": "Daftar langganan",
      "description": "Daftar langganan domain Anda"
    },
    "table": {
      "domain": "Domain",
      "plan": "Paket",
      "status": "Status",
      "card": "Kartu",
      "usage": "Penggunaan",
      "actions": "Aksi",
      "payment_method": "Metode Pembayaran"
    },
    "usage": {
      "paid": "{{words_used}} / {{words_allowed}} kata",
      "paidOffered": "{{words_used}} / {{words_allowed}} kata\n(Termasuk {{free_words}} kata gratis)"
    },
    "popup": {
      "dueToday": "Total jatuh tempo hari ini",
      "nextPeriod": "Mulai dari {{date}}"
    }
  },
  "topbar": {
    "accounts": {
      "choose": "Pilih akun"
    }
  },
  "translation": {
    "main": {
      "parent": "Terjemahan",
      "edit": "Edit terjemahan"
    },
    "form": {
      "original": {
        "title": "Asli dalam {{language}}"
      },
      "is_inline": "Terjemahan ini dibuat dari konten inline.",
      "inline_editor": {
        "count_warning": "Jumlah area sebaris tidak sama dengan teks asli ({{current}} dari {{expected}}).",
        "restore_original": "Pulihkan teks asli",
        "insert_placeholder": "Sisipkan placeholder",
        "drag": "Seret untuk mengubah urutan area",
        "area": "Area inline {{index}}",
        "restore": "Pulihkan area sebaris yang hilang"
      },
      "translation": {
        "title": "Terjemahan dalam {{language}}",
        "description": "Terjemahan yang ingin Anda timpa"
      }
    },
    "copy": {
      "title": "Salin ke terjemahan manual",
      "label": "Salin ke manual"
    },
    "level": {
      "base": {
        "title": "Terjemahan dasar",
        "subtitle": "Otomatis · Terjemahan Linguise Cloud",
        "empty": "Tidak ada terjemahan dasar untuk teks ini.",
        "overridden": "Pilihan Anda tersimpan, tetapi terjemahan terbaru yang ditingkatkan AI ditampilkan sebagai gantinya karena “Timpa terjemahan manual dan yang dipilih” bernilai Ya di pengaturan Terjemahan AI. Matikan pengaturan itu untuk menggunakan pilihan Anda."
      },
      "not_generated": "Belum dibuat",
      "none": "Belum ada",
      "ai": {
        "title": "Terjemahan yang ditingkatkan AI",
        "subtitle": "Otomatis · Linguise AI",
        "empty_title": "Belum dibuat untuk teks ini",
        "empty_description": "Linguise AI menghasilkan terjemahan yang lebih natural dengan memanfaatkan konteks halaman dan situs web Anda. Untuk mendapatkannya di sini:",
        "empty_step_1": "Buka Terjemahan AI › Pengaturan, lalu setel Aktifkan terjemahan AI ke “Hanya aturan”, “Hanya editor antarmuka”, atau “Aturan dan editor antarmuka”.",
        "empty_step_2": "Terapkan dengan Aturan yang cocok dengan halaman ini, atau aktifkan per halaman dari Editor Antarmuka.",
        "empty_step_3": "Terjemahan yang ditingkatkan AI akan muncul di sini setelah dibuat. Terjemahan ini menggunakan kredit AI Anda.",
        "open_settings": "Buka pengaturan Terjemahan AI",
        "open_editor": "Buka Live Editor",
        "overrides_selection": "Pilihan Anda tersimpan, tetapi terjemahan yang ditingkatkan AI ini ditampilkan sebagai gantinya karena “Timpa terjemahan manual dan yang dipilih” bernilai Ya di pengaturan Terjemahan AI. Matikan pengaturan itu untuk menggunakan pilihan Anda.",
        "overrides_version": "Versi yang Anda pilih tersimpan, tetapi versi terbaru yang ditingkatkan AI ditampilkan sebagai gantinya karena “Timpa terjemahan manual dan yang dipilih” bernilai Ya di pengaturan Terjemahan AI. Matikan pengaturan itu untuk menggunakan versi yang dipilih."
      },
      "manual": {
        "title": "Terjemahan manual",
        "subtitle": "Ditulis oleh Anda · diprioritaskan di atas terjemahan otomatis",
        "empty": "Kosong",
        "saved_but_overridden": "Tersimpan sebagai pilihan Anda, tetapi tidak ditampilkan otomatis karena “Timpa terjemahan manual” bernilai Ya di pengaturan Terjemahan AI: terjemahan yang ditingkatkan AI diutamakan hingga pengaturan itu dimatikan.",
        "ignored": "Tidak ditampilkan otomatis karena “Timpa terjemahan manual” bernilai Ya di pengaturan Terjemahan AI. Pilih terjemahan ini untuk menggunakannya pada teks ini.",
        "label": "Terjemahan Anda",
        "placeholder": "Ketik terjemahan Anda sendiri...",
        "last_updated": "Terakhir diedit {{date}}",
        "save_hint": "Menyimpan terjemahan manual akan mengaktifkannya.",
        "delete": "Hapus terjemahan manual",
        "delete_confirm": "Harap konfirmasi penghapusan terjemahan manual"
      }
    },
    "history": {
      "title": "Versi yang ditingkatkan AI",
      "subtitle": "Setiap pembuatan ulang dari Editor Antarmuka disimpan",
      "unknown_model": "Model tidak diketahui",
      "current": "Saat ini",
      "restore": "Pulihkan versi ini",
      "restore_note": "Memulihkan akan menjadikan versi tersebut terjemahan yang ditingkatkan AI saat ini. Tidak ada yang dihapus.",
      "version_of": "Versi {{current}} dari {{total}}",
      "hide": "Sembunyikan riwayat ({{total}})",
      "show": "Tampilkan riwayat ({{total}})"
    },
    "choose": {
      "title": "Terjemahan dalam {{language}} · pilih yang dilihat pengunjung",
      "current": "Saat ini di situs web Anda:",
      "priority": "Prioritas default: Manual › Ditingkatkan AI › Dasar. Pilihan Anda hanya disimpan untuk terjemahan ini.",
      "reset": "Setel ulang ke prioritas default",
      "reset_title": "Lupakan pilihan Anda untuk teks ini dan gunakan kembali prioritas default",
      "resetting": "Menyetel ulang ..."
    }
  },
  "translations": {
    "title": "Manajemen terjemahan",
    "description": "Daftar dan edit semua terjemahan situs web Anda, untuk terjemahan visual gunakan Editor Antarmuka kami",
    "filter_languages": "Filter berdasarkan bahasa...",
    "filter_original": "Filter teks dalam bahasa asli",
    "filter_translation": "Filter berdasarkan teks terjemahan",
    "table": {
      "original": "Asli",
      "language": "Bahasa",
      "action": "Aksi",
      "base": "Dasar",
      "ai": "Ditingkatkan AI",
      "manual": "Manual"
    },
    "filter_exact": "Kecocokan tepat",
    "badge": {
      "active": "Aktif",
      "overrides_manual": "Menimpa manual"
    },
    "cell": {
      "none": "tidak ada",
      "not_generated": "belum dibuat",
      "ignored": "Diabaikan – aturan AI menang"
    },
    "tabs": {
      "all": "Semua",
      "manual": "Ada manual",
      "ai": "Ada AI",
      "base": "Hanya dasar"
    },
    "levels_hint": "Setiap teks memiliki hingga 3 tingkat — yang ditandai Aktif adalah yang dilihat pengunjung."
  },
  "url": {
    "main": {
      "parent": "URL",
      "edit": "Edit terjemahan URL"
    },
    "form": {
      "original": {
        "title": "Asli dalam {{language}}"
      },
      "translation": {
        "title": "Terjemahan URL dalam {{language}}",
        "description": "URL yang ingin Anda timpa",
        "placeholder": "Timpa terjemahan URL",
        "invalid_full": "Anda mencoba mengubah dengan format yang salah, Anda hanya boleh mengubah slug/pathname terjemahan URL",
        "invalid": "URL/path tidak valid"
      }
    }
  },
  "urls": {
    "title": "Manajemen URL",
    "description": "Daftar dan edit semua konten URL situs web Anda yang diterjemahkan (lanjutan, hati-hati terhadap error 404)",
    "filter_languages": "Filter berdasarkan bahasa...",
    "filter_original": "Filter teks dalam bahasa asli",
    "filter_translation": "Filter berdasarkan teks terjemahan",
    "table": {
      "original": "Asli",
      "language": "Bahasa",
      "url": "URL Terjemahan",
      "action": "Aksi",
      "edited": "Terjemahan asli telah diedit"
    }
  }
}
